/* Occupations list is stored in CRS, for given brand under "occupations" SingleRowText group */
export const OCCUPATIONS_CRS_GROUP_KEY = "occupations";
